import {Messages} from '../../constants';

const validation = {
  nomeCompleto: {
    presence: {
      message: Messages.RequiredEmbossingValidationMessage,
      allowEmpty: false,
    },
    length: {
      maximum: 19,
      message: Messages.EmbossingValidationTooLong,
    },
    format: {
      pattern: /(\w.+\s).+/i,
      message: Messages.RequiredEmbossingFullValidationRequiredMessage,
    },
  },
  sexo: {
    presence: {
      message: Messages.RequireGenderValidationMessage,
      allowEmpty: false,
    },
  },
  dataNascimento: {
    presence: {
      message: Messages.RequiredAditionalBirthdateValidationMessage,
      allowEmpty: false,
    },
    brDate: {
      message: Messages.InvalidBirthdateValidationMessage,
    },
    under16Years: {
      message: Messages.Under16YearsValidationMessage,
    },
    over100Years: {
      message: Messages.Over100YearsValidationMessage,
    },
  },
  parentesco: {
    presence: {
      message: Messages.RequiredRelationshipMessage,
      allowEmpty: false,
    },
  },
};

export default validation;
